
<template>
    <div class="container-fluid loginPages p-0">
      <div class="container py-3 py-md-4 px-0">
        <div class="row d-block m-0">
          <img src="static/images/logo.png" class="img-fluid">
          <router-link class="saas-btn mt-0 float-right" to="/login">{{$ml.get('LOGIN')}}</router-link>
        </div>
      </div>
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
      <div class="container mt-3 mb-5 px-0">
        <div class="row loginInfo">
          <div class="col-12 col-md-6">
             <h2 class="title">{{$ml.get('ALREADY_REGISTERED')}}</h2>
             <router-link class="saas-btn saas-btn-transparent mt-4 saas-btn" to="/login">{{$ml.get('LOGIN')}}</router-link>
          </div>
          <div class="col-12 col-md-6 mt-4 mt-md-0">
  
            <h2 class="title" v-if="key!==undefined">{{$ml.get('COMPLETE_REGISTRATION')}}</h2>
            <h2 class="title" v-else>{{$ml.get('REGISTER')}}</h2>
            <div>
              <form class="signup-form saas-form" v-on:submit.prevent="signUp">
                <div class="row">
                   <div class="col-6">
                      <label for="name" class="saas-label">{{$ml.get('NAME')}}</label>
                      <div class="saas-form-control" :class="{isDanger:nameError.state==true}">
                        <input type="text" @input="nameValidation" class="saas-input" v-model="name">
                        <div class="col-12 d-block px-0 input-error">
                          <span class="alert-input" v-if="nameError.state">{{nameError.message}}</span>
                        </div>
                      </div>
                   </div>
                   <div class="col-6">
                      <label for="surName" class="saas-label">{{$ml.get('SURNAME')}}</label>
                      <div class="saas-form-control" :class="{isDanger:surNameError.state==true}">
                        <input type="text" @input="surNameValidation" class="saas-input" v-model="surName">
                        <div class="col-12 d-block input-error px-0">
                          <span class="alert-input" v-if="surNameError.state">{{surNameError.message}}</span>
                        </div>
                      </div>
                   </div>
                </div>
                <!-- Tel no ekleme -->
                <div class="row">
                    <div class="col-12">
                      <label for="phone" class="saas-label">{{$ml.get('PHONE_NUMBER')}}</label>
                      <div class="saas-form-control" :class="{isDanger:phoneError.state==true}">
                          <input type="number" @input="phoneValidation" class="saas-input" v-model="phone">
                          <div class="col-12 d-block input-error px-0">
                              <span class="alert-input" v-if="phoneError.state">{{phoneError.message}}</span>
                          </div>
                      </div>
                    </div>
                </div>
                
                <div class="row" v-if="key==undefined">
                    <div class="col-12">
                      <label for="email" class="saas-label">{{$ml.get('E_MAIL')}}</label>
                      <div class="saas-form-control" :class="{isDanger:emailError.state==true}">
                          <input type="text" @input="emailValidation" class="saas-input" v-model="email">
                          <div class="col-12 d-block input-error px-0">
                          <span class="alert-input" v-if="emailError.state">{{emailError.message}}</span>
                          </div>
                      </div>
                    </div>
                </div>
                <div class="row">
                   <div class="col-6">
                      <label for="password" class="saas-label">{{$ml.get('PASSWORD')}}</label>
                      <div class="saas-form-control" :class="{isDanger:passwordError.state==true}">
                        <input type="password" @input="passwordValidation" class="saas-input" v-model="password">
                        <div class="col-12 d-block input-error px-0">
                          <span class="alert-input" v-if="passwordError.state">{{passwordError.message}}</span>
                        </div>
                      </div>
                   </div>
                   <div class="col-6">
                      <label for="rePassword" class="saas-label">{{$ml.get('PASSWORD_REPEAT')}}</label>
                      <div class="saas-form-control" :class="{isDanger:rPasswordError.state==true}">
                        <input type="password" @input="rPasswordValidation" class="saas-input" v-model="rePassword">
                        <div class="col-12 d-block input-error px-0">
                          <span class="alert-input" v-if="rPasswordError.state">{{rPasswordError.message}}</span>
                        </div>
                      </div>
                   </div>
                </div>
                <div class="row">
                    <div class="col-12">
                      <label for="email" class="saas-label">{{$ml.get('TIMEZONE')}}</label>
                      <div class="saas-form-control">
                          <select v-model="timeZone" class="saas-input">
                              <option v-for="(timezone,index) in timezones" :key="index" :value="timezone">{{timezone}}</option>
                          </select>
                          <div class="col-12 d-block input-error px-0">
                            <span class="alert-input"></span>
                          </div>
                      </div>
                    </div>
                </div>

                <div class="form-check">
                    <label for="gdprPermission" v-if="$ml.current!=='tr'">
                      <input type="checkbox" id="gdprPermission" v-model="gdprPermission" class="mr-2">Once you tick the box you accept
                      <a href="javascript:void(0)" :title="$ml.get('TERMS_OF_SERVICE')" data-toggle="modal" data-target="#kullanim-kosullari">{{$ml.get('TERMS_OF_SERVICE')}}</a> and
                      <a href="javascript:void(0)" :title="$ml.get('PRIVACY_POLICY')" data-toggle="modal" data-target="#gizlilik-politikasi">{{$ml.get('PRIVACY_POLICY')}}</a>
                       statements by Minimum CRM
                    </label>
                    <label for="gdprPermission" v-else>
                      <input type="checkbox" id="gdprPermission" v-model="gdprPermission" class="mr-2">Devam ettiğinizde 
                      <a href="javascript:void(0)" :title="$ml.get('TERMS_OF_SERVICE')" data-toggle="modal" data-target="#kullanim-kosullari">{{$ml.get('TERMS_OF_SERVICE')}}</a> ve
                      <a href="javascript:void(0)" :title="$ml.get('PRIVACY_POLICY')" data-toggle="modal" data-target="#gizlilik-politikasi">{{$ml.get('PRIVACY_POLICY')}}</a> Sözleşmesi’ni kabul etmiş sayılırsınız.
                    </label>
                        
                    <span class="alert-input" v-if="gdprError.state">{{gdprError.message}}</span>
                </div>
                <div class="form-check">
                  <label for="campaignAlert" v-if="$ml.current!=='tr'">
                    <input type="checkbox" id="campaignAlert" v-model="campaignAlert" class="mr-2">Minimum CRM can send me e-mails regarding new features and promotions.
                  </label>
                  <label for="campaignAlert" v-else>
                    <input type="checkbox" id="campaignAlert" v-model="campaignAlert" class="mr-2">Minimum CRM yeni özellikler ve kampanyalar hakkında bilgilendirme mesajları gönderebilir.
                  </label>
                </div>
                <button type="submit" class="saas-btn mt-3">{{$ml.get('REGISTER')}}</button>
                
              </form>
            </div>
          </div>
        </div>
      </div>
      <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
      
      <div class="modal fade" id="resultAlert" ref="resultAlert" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div class="" >
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 text-center">
                      <img src="@/assets/aktivasyon_gonderildi.png" class="img-fluid">
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12">
                    {{$ml.get('PLEASE_CLICK_ACTIVATION_LINK')}}
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
               <button type="button" class="btn btn-primary" data-dismiss="modal">{{$ml.get('OKEY')}}</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="successActivation" ref="successActivation" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="successActivation" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div class="" >
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 text-center">
                      <img src="/static/images/done-payment-icon.png" class="img-fluid">
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12">
                    {{$ml.get('ACTIVATION_SUCCESS')}}
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
               <button type="button" class="btn btn-primary" data-dismiss="modal">{{$ml.get('OKEY')}}</button>
            </div>
          </div>
        </div>
      </div>
      <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
      <Footer></Footer>
    </div>
</template>
  
<script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  import {mapActions} from 'vuex'
  import Footer from './footer.vue'
  import Swal from 'sweetalert2'
  import moment from 'moment-timezone'

  import swal from 'sweetalert'
  export default {
        name: 'SignUp',
        data () {
            return {
            key:undefined,
            name:'',
            surName:'',
            companyName:'',
            phone:'',
            password:'',
            email:'',
            password:'',
            rePassword:'',
            gdprPermission:false,
            campaignAlert:true,
            nameError:{state:false,message:''},
            surNameError:{state:false,message:''},
            phoneError:{state:false,message:''},
            companyNameError:{state:false,message:''},
            emailError:{state:false,message:''},
            passwordError:{state:false,message:''},
            rPasswordError:{state:false,message:''},
            gdprError:{state:false,message:''},
            timeZone:'Etc/UTC'
            }
        },
        computed: {
            ...mapState([
                'baseUrl',
                'townList',
                'timezones'
            ]) 
        },
        components:{
            Footer
        },
        methods:{
            isLogin(){
            axios({
                method:'GET',
                url:'/authenticate',
                baseURL: this.baseUrl,
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    this.$router.push('/deals')
                }else{
                }
            })
            },

            signUp(){

                this.nameValidation()
                this.surNameValidation()
                this.phoneValidation()
                if(this.key===undefined){
                  this.emailValidation()
                }
                this.passwordValidation()
                this.rPasswordValidation()
                this.gdprValidation()
                if(!this.emailValidation() && this.key===undefined){
                  return false
                }

                if(
                    !this.nameValidation() ||
                    !this.surNameValidation() ||
                    !this.phoneValidation() ||
                    !this.passwordValidation() || 
                    !this.rPasswordValidation() ||
                    !this.gdprValidation()
                ){
                    return false
                }
                var data={}
                data={
                  name:this.name,
                  surName:this.surName,
                  companyName:this.companyName,
                  phone:this.phone,
                  password:this.password,
                  address:this.address,
                  timeZone:this.timeZone,
                  contractConfirm:this.gdprPermission,
                  bulletinConfirm:this.campaignAlert
                }
                if(this.key===undefined){
                    var url='/createUser'
                    data['email']=this.email
                }else{
                    var url='/updatePreCreatedUser'
                    data['key']=this.key
                }
                 
                axios({
                method:'POST',
                url:url,
                baseURL: this.baseUrl,
                data: data,
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status.code==0){
                     
                    if(this.key===undefined){
                       $("#resultAlert").modal("show")
                    }else{
                      
                      Swal.fire({
                          title: this.$ml.get('SUCCESSFUL'),
                          html: this.$ml.get('ACTIVATION_SUCCESS'),
                          icon: "success",
                          showCancelButton: false,
                          showConfirmButton: false,
                          timer:3000
                      }).then(
                        setTimeout(() => this.$router.push('/login') , 3000)
                      )
                    }

                    if(this.$route.query.ref=='lp'){
                      //gtag_report_conversion()
                      var callback = function () {
                        if (typeof(url) != 'undefined') {
                          window.location = url;
                        }
                      };
                      this.$gtag.event("conversion", {
                        'send_to': 'AW-1035745183/tV44CIelv_ABEJ_v8O0D',
                        'event_callback': callback
                      })
                    }else if(this.$route.query.ref=='emlak'){
                      var callback = function () {
                        if (typeof(url) != 'undefined') {
                          window.location = url;
                        }
                      };
                      gtag('event', 'conversion', {
                          'send_to': 'AW-1035745183/IoaeCIqbjPkBEJ_v8O0D',
                          'event_callback': callback
                      });
                    }else if(this.$route.query.ref=='excel'){
                      var callback = function () {
                        if (typeof(url) != 'undefined') {
                          window.location = url;
                        }
                      };
                      gtag('event', 'conversion', {
                          'send_to': 'AW-1035745183/mRE5CPzdjPkBEJ_v8O0D',
                          'event_callback': callback
                      });
                    }else if(this.$route.query.ref=='en'){
                      var callback = function () {
                        if (typeof(url) != 'undefined') {
                          window.location = url;
                        }
                      };
                      gtag('event', 'conversion', {
                          'send_to': 'AW-1035745183/qdm_CMCk-PgBEJ_v8O0D',
                          'event_callback': callback
                      });
                    }
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                    //this.$router.push('/login')
                }      
                })

            },
            nameValidation(){
                this.nameError.message=''
                if(this.name==''){
                    this.nameError.message=this.$ml.get('PLEASE_ENTER_YOUR_NAME')
                    this.nameError.state = true
                    return false
                }
                this.nameError.state = false
                return true
            },
            surNameValidation(){
                this.surNameError.message=''
                if(this.surName==''){
                    this.surNameError.message=this.$ml.get('PLEASE_ENTER_YOUR_SURNAME')
                    this.surNameError.state = true
                    return false
                }
                this.surNameError.state = false
                return true
            },
            phoneValidation(){
                this.phoneError.message=''
                if(this.phone==''){
                    this.phoneError.message=this.$ml.get('PLEASE_ENTER_YOUR_PHONE')
                    this.phoneError.state = true
                    return false
                }
                this.phoneError.state = false
                return true
            },
            validateEmail(email) {
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },
            emailValidation(){
                this.emailError.state = false
                this.emailError.message=''
                if(this.email==''){
                    this.emailError.message= this.$ml.get('PLEASE_ENTER_YOUR_MAIL')
                    this.emailError.state = true
                    return false
                }
                else if(!this.validateEmail(this.email)){
                    this.emailError.message= this.$ml.get('PLEASE_ENTER_VALID_MAIL')
                    this.emailError.state = true
                    return false
                }
                this.emailError.state = false
                return true
                
            },
            
            passwordValidation(){
                this.passwordError.messages = []
                this.passwordError.state = false
                if(this.password==''){
                    this.passwordError.message= this.$ml.get('PLEASE_SET_PASSWORD')
                    this.passwordError.state = true
                    return false
                }
                this.passwordError.state = false
                return true
            },
            rPasswordValidation(){
                this.rPasswordError.message = ""
                this.rPasswordError.state = false
                
                if(this.rePassword==''){
                    this.rPasswordError.message = this.$ml.get('PLEASE_RE_ENTER_PASSWORD')
                    this.rPasswordError.state = true
                    return false
                }else if(this.password!==this.rePassword){
                    this.rPasswordError.message =  this.$ml.get('PASSWORD_DO_NOT_MATCH')
                    this.rPasswordError.state = true
                    return false
                }
                this.rPasswordError.state = false
                return true
                
            },
            gdprValidation(){
                this.gdprError.message = ""
                this.gdprError.state = false
                if(!this.gdprPermission){
                    this.gdprError.message = this.$ml.get('MUST_BE_CHECKED')
                    this.gdprError.state = true
                    return false
                }else{
                    return true
                }
            },
            claarPush(){
              this.$router.push('/login')
            },
            ...mapActions([
                'updateLoading',
            ]),
      },
      mounted(){
          $(this.$refs.resultAlert).on("hidden.bs.modal", this.claarPush)
          
      },
      created(){  
        if(this.$route.query.key!==undefined){
          this.key = this.$route.query.key
        }else{
          this.key=undefined
        }
        this.isLogin()
        this.timeZone = moment.tz.guess()
        var referrer = document.referrer;
        console.log("referrer")
        console.log(referrer)
        
      }
  }
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  @import url("https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700,900");
  body{
      background-color: #E5E5E5 !important;
      color: #677294;
    }
    
    select+div.input-error{
      height: 40px !important;
    }
  .form-check{
    padding-top: 0.5rem;
    padding-left: 0rem;
  }
  .form-check label{
    cursor: pointer;
    line-height: 25px;
  }
  h1{
    color: white;
  }
  .form-check{
    font-size: 0.9rem;
  }
  </style>
  